import React, { useEffect, useState } from "react";
import "./charts.css";
import KnowiChart from "./charts";
import { Button, TextLink, TextLinkCaret } from "@vds/buttons";
import { TextLinkCaretButton } from "../Dashboard/styles";
import { Icon } from "@vds/icons";
import { Toggle } from "@vds/toggles";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { Title, Body } from "@vds/typography";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { Input } from "@vds/inputs";
import { showNotificationBanner, updateBaselineInfo } from "../../store/actions";
import { getWidgetLocationName } from "../../global/utility/widgetUtils";
import { formatUTCTime, updateSiteTag } from "../../global/utility/Utils";
import { setAllTagList, putProcessedSiteTagList } from "../../../src/store/actions";
import { DropdownSelect } from "@vds/selects";
import { getBaseLineCountText,
  setForceResetForBaseLineCount,
  getNotificationObj,
  setTagsBaseLineCount,
  getDeviceVirtualIdFromTagId,
  convertTimeToDropdownValue,
convertTimeToBaseLineDropdownValue} from "../../global/utility/statisticsUtil";
 import VisionModalPopComponent from "../../global/components/VisionModalPopComponent";


const BaselineCount = ({
  siteNameForViewTag,
  appName,
  tagIdList,
  filteredTagsListArray,
  tagListItem,
  sitesTagList,
  encryptPayload,
  roisListWithApps,
  cvappName,
  postForceRestAction,
  setShowHideFilter,
  showHideFilter,
  setBaselineDataSourcesToggleDropdown,
  statBaseSettingsTag
}) => {
 
const dispatch = useDispatch();
const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
);
const appImageNameFromAppName = appName.replaceAll(" ", "");
  
const [statisticForceReset, setStatisticForceReset] = useState(false);
const [statisticCountSettings, setStatisticCountSettings] = useState(false);
const [baseResetData, setBaseResetData] = useState({});
const allBaselineData = useSelector((state) => state.statisticsReducer.tagBaseline);
 const getvirtualIdFromLocationName = (locationId) =>{
    return getDeviceVirtualIdFromTagId(locationId, roisListWithApps, cvappName);
  }
const [baseSettingsTag, setBaseSettingsTag] = useState(statBaseSettingsTag.length > 0 ? statBaseSettingsTag[0] :  baseResetData?.baseLineTag);
const [forceResetCount, setforceResetCount] = useState("");
const countBaseFromTrigger = allBaselineData.find((i) => {return (i?.customdata.deviceid === getvirtualIdFromLocationName(statBaseSettingsTag[0].id))   })?.customdata?.fieldvalue.toString();
const [baseSettingsSelectedCount, setBaseSettingsSelectedCount] = useState( countBaseFromTrigger == NaN || countBaseFromTrigger == undefined ? "" : countBaseFromTrigger);
const [selectedTime, setSelectedTime] = useState(convertTimeToBaseLineDropdownValue(allBaselineData,statBaseSettingsTag, roisListWithApps, cvappName));

var vid = getvirtualIdFromLocationName(statBaseSettingsTag[0].id);
const [baselineToggleChecked, setBaselineToggleChecked] = useState(allBaselineData.find((i) => {return (i?.customdata.deviceid === getvirtualIdFromLocationName(statBaseSettingsTag[0].id)) })?.customdata?.isactive );

  const submitBaseResetData = async (baseResetData) => {
    const payload = 
    {
      "accountname": activeSession?.accountId,
      "schedule": {
        "deviceid": getvirtualIdFromLocationName(baseSettingsTag.id),
        "fieldname": (appImageNameFromAppName == "ParkingOccupancy") ? "ParkingBayOccupancyEE.count" : appImageNameFromAppName+"EE" + ".count",
        "fieldvalue": parseInt(baseSettingsSelectedCount),
        "starttime": new Date(new Date(Date.now()).setHours(selectedTime, '00', '00')).toISOString(),
        "isactive": baselineToggleChecked == undefined ? false : baselineToggleChecked
      }
    }
    const result = await setTagsBaseLineCount(payload);
    if (result?.status == 200 || result?.status == 202 ) {
      const notificationInfo = getNotificationObj('Baseline count settings changed successfully.', true) 
      dispatch(showNotificationBanner(notificationInfo))
      setBaseResetData(baseResetData);
      dispatch(updateBaselineInfo(result.data));
    } else {
      console.error("Failed to update baseline data");
      const notificationInfo = getNotificationObj('Unable to update Baseline count settings successfully.', false);
      dispatch(showNotificationBanner(notificationInfo))
    }
    setBaseSettingsSelectedCount("0")
    setSelectedTime("01");
  }; 
  const handleForceReset = () => {
    setStatisticForceReset(false);
    setTimeout(() => {
      setStatisticForceReset(true);
      setShowHideFilter(false);
      }, 100)
  }

  const handleSubmitForceRestCount = async (baseSettingsTag) => {
    const contentFilter = {
      "accountname": activeSession?.accountId,
      "resourceidentifier": {
        "deviceid": getvirtualIdFromLocationName(baseSettingsTag.id)
      },
      "counter": {
        "cvapp":(appImageNameFromAppName == "ParkingOccupancy") ? "ParkingBayOccupancyEE" : appImageNameFromAppName+"EE",
        "value": parseInt(forceResetCount)
      }
    }
    const forceResetResponse = await setForceResetForBaseLineCount(contentFilter);
    let notificationInfo ={};
        if(forceResetResponse.status == 200){
          notificationInfo =    getNotificationObj('Baseline count settings changed successfully.', true);
          postForceRestAction();
        }else{
          notificationInfo =  getNotificationObj('Unable to update Baseline count settings successfully.', false) ;
        }
    dispatch(showNotificationBanner(notificationInfo));
  }

 

  const handleCountSettings= () => {
    setStatisticCountSettings(false);
    setTimeout(() => {
      setStatisticCountSettings(true);
      setShowHideFilter(false);
      }, 100)
  }

  const handleBaselineToggle = (e) =>{
    setBaselineToggleChecked(e.target.checked);
  }

  const positiveNumberRegex = /^(?:0|[1-9]\d*)(?:\.\d+)?$/;

  return (
    <>
    <div  className=""> 
        <div style={{display:"flex", flexDirection:"column", paddingLeft:"10px"}}> <b>Baseline count </b></div> 
        <div style={{display:"flex", flexDirection:"column"}}>
          <ul>
              <li onClick={() => {handleCountSettings()}}>
              <span> Configure baseline settings </span>
              </li>
              <li style={{borderBottom:"1px solid #d8dada"}} onClick={() => handleForceReset()}>
              <span> Force reset baseline </span>
              </li>
          </ul></div>
    </div>  
<VisionModalPopComponent
        opened={statisticForceReset}
        title="Force reset baseline count"
        disableOutsideClick={true}
        hideCloseButton={true}
        children={
          <div >
                    <Body size="large" viewport="desktop" primitive="h2">
                      Are you sure you’d like to force reset the baseline count? This will reset the total count for <b>{siteNameForViewTag}</b> to the selected number immediately.
                    </Body>
                      <div style={{ width: "auto", display: "flex", flexDirection: 'row', gap: '10px'}}>

                        <div style={{width:'auto', marginTop:'20px'}}>
                        <DropdownSelect
                          label="Tag"
                          errorText="Select a Tag"
                          error={false}
                          disabled={false}
                          readOnly={false}
                          onChange={(e) => {
                            setBaseSettingsTag({id:e.target.value, name:getWidgetLocationName(e.target.value,tagListItem)});
                            allBaselineData.map((i) => {
                            if (i?.customdata.deviceid === getvirtualIdFromLocationName(e.target.value)) {
                              setforceResetCount(i?.customdata.fieldvalue.toString());
                            }
                            else {
                              setforceResetCount("0");
                            }
                            });
                          }}
                          value={baseSettingsTag.id}
                          helperText= {baseSettingsTag.id == "select" ? "Please select location" : ""}
                          helperTextPlacement="bottom"
                        >
                          <option value = {"select"}>Select</option>
                          {Array.isArray(filteredTagsListArray) &&
                            filteredTagsListArray?.filter((obj, index, self) =>
                              index === self.findIndex((t) => t.id === obj.id) && getvirtualIdFromLocationName(obj?.id)
                          )
                          .map((item) => (
                              <option value={item?.id}>{item?.name}</option>
                          ))}
                        </DropdownSelect></div>
                        <div className="baseLineInputDivPeopleCount">
                        <Input
                          type="text"
                          label={getBaseLineCountText(appName.split('_')[0])}
                          readOnly={false}
                          required={true}
                          disabled={false}
                          value={forceResetCount}
                          helperText= {forceResetCount == "" ? "Please Enter valid count" : ""}
                          helperTextPlacement="bottom"
                          onChange={(e) => {
                          if (positiveNumberRegex.test(e.target.value.toString()) || e.target.value.toString() === "") {
                            setforceResetCount(e.target.value.toString());
                          }
                          }}
                        />
                        </div>
                    </div> 
                  </div>
        }
        primaryButton={{
          label: "Save",
          onClick: async () => {
                        var d = new Date(Date.now());
                        handleSubmitForceRestCount(baseSettingsTag);
                        setStatisticForceReset(false);
                        
                      },
          disabled: baseSettingsTag?.id==='select' || baseSettingsTag === undefined || forceResetCount === "",
          width: "350px"
        }}
        closeButton={{
          label: "Cancel",
          onClick: () => {
                        setStatisticForceReset(false);
                        setBaselineDataSourcesToggleDropdown(false);
                        
                      },
          width: "350px"
        }}
      >
        {/* Modal content */}
      </VisionModalPopComponent>
      <VisionModalPopComponent
        opened={statisticCountSettings}
        title="Set baseline"
        disableOutsideClick={true}
        hideCloseButton={true}
        children={
          <div>
              <Body size="small" viewport="desktop" primitive="h2">
              Enabling the baseline count allows you to set a time at which the count should reset to a chosen number at the selected location.
(Example:  Reset count to<b> 0 people</b> at <b>3:00am</b>).
              </Body>

<div  style={{width:'100%', marginTop: '20px', display:'flex', flexDirection: 'row'}}>

              <div style={{width:"30%"}}>
                <div><b>Enable baseline</b></div>
                 <div style={{ marginTop:"10px"}}>
                      <Toggle disabled={false} showText={false} on={baselineToggleChecked == true}
                      onChange={(e)=>{
                               handleBaselineToggle(e);
                       }

                                    } />
                                  </div>
              </div>
              <div  className="baseLineTagInpoutDropDown"><DropdownSelect
                  label="Tag"
                  errorText="Select a Tag"
                  error={false}
                  disabled={false}
                  readOnly={false}
                  value={baseSettingsTag?.id}
                  onChange={(e) => {
                    setBaseSettingsTag({id:e.target.value, name:getWidgetLocationName(e.target.value,tagListItem)});
                    allBaselineData.forEach((i) => {
                     if (i?.customdata.deviceid === getvirtualIdFromLocationName(e.target.value)) {
                      setBaseSettingsSelectedCount(i?.customdata.fieldvalue.toString());
                      var d =  convertTimeToDropdownValue(i?.lastupdated.split("T")[0] + "T" + i?.starttime.split("T")[1]);
                      setSelectedTime(d);
                      return;
                     }
                    });
                  }}
                >
                  <option>Select</option>
                  {Array.isArray(filteredTagsListArray) &&
                    filteredTagsListArray?.filter((obj, index, self) =>
                      index === self.findIndex((t) => t.id === obj.id)  && getvirtualIdFromLocationName(obj?.id)
                  )
                    .map((item) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}
                </DropdownSelect></div>
              </div>

              {  (<div className="baseLineInputDiv">
             
              <div className="baseLineCountTimeDropDown">
                <DropdownSelect
                  width="90%"
                  label="Reset Time"
                  errorText="Select a App"
                  error={false}
                  disabled={false}
                  readOnly={false}
                  inlineLabel={false}
                  value={selectedTime}
                  onChange={async (e) => {
                    setSelectedTime(e.target.value);
                  }}
                >
                  <option value="00">12AM</option>
                  <option value="01">1AM</option>
                  <option value="02">2AM</option>
                  <option value="03">3AM</option>
                  <option value="04">4AM</option>
                  <option value="05">5AM</option>
                  <option value="06">6AM</option>
                  <option value="07">7AM</option>
                  <option value="08">8AM</option>
                  <option value="09">9AM</option>
                  <option value="10">10AM</option>
                  <option value="11">11AM</option>
                  <option value="12">12PM</option>
                  <option value="13">1PM</option>
                  <option value="14">2PM</option>
                  <option value="15">3PM</option>
                  <option value="16">4PM</option>
                  <option value="17">5PM</option>
                  <option value="18">6PM</option>
                  <option value="19">7PM</option>
                  <option value="20">8PM</option>
                  <option value="21">9PM</option>
                  <option value="22">10PM</option>
                  <option value="23">11PM</option>
                </DropdownSelect></div>
                <div style={{ display: "flex",flexDirection: 'row' }}>
                  <Input
                    type="text"
                    label={getBaseLineCountText(appName.split('_')[0])}
                    readOnly={false}
                    required={true}
                    disabled={false}
                    error={false}
                    errorText="Enter a valid count."
                    value={baseSettingsSelectedCount}
                    onChange={(e) => {
                      if(positiveNumberRegex.test(e.target.value.toString()) || e.target.value.toString() === ""){
                        setBaseSettingsSelectedCount(e.target.value.toString());
                      }
                    } }
                  />
                </div>
              </div> )}
            </div>
        }
        primaryButton={{
          label: "Save",
          onClick: () => {
                  const selectedBaseResetData = ({baseLineCount: baseSettingsSelectedCount, baseLineTag: baseSettingsTag, forceResetTimeStamp: new Date().toISOString()});
                   submitBaseResetData(selectedBaseResetData);
                  setStatisticCountSettings(false);
                  
                },
          disabled: baseSettingsTag?.id==='select' || baseSettingsTag === undefined || baseSettingsSelectedCount === "",
          width: "350px"
        }}
        closeButton={{
          label: "Cancel",
          onClick: () => {
                  setStatisticCountSettings(false);
                  setBaselineDataSourcesToggleDropdown(false);
                },
          width: "350px"
        }}
      >
        {/* Modal content */}
      </VisionModalPopComponent>
    </>
  );
};
export default BaselineCount;